import { render, staticRenderFns } from "./DialogAppointment.vue?vue&type=template&id=3719cc8a"
import script from "./DialogAppointment.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogAppointment.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports